import React from 'react';

import AppRoutes from '../AppRoutes';
import Layout from '@crema/core/Layout';
import ChannelAdminTheme from '../theme/ChannelAdminTheme';
import { removeSessionStorage, SESSION_STORAGE_NAMES } from '@libs/storage/src/lib/session';

removeSessionStorage(SESSION_STORAGE_NAMES.CHANNEL_ID);

const AppLayout = () => {
  return (
    <ChannelAdminTheme>
      <Layout appRouter={AppRoutes} />
    </ChannelAdminTheme>
  );
};

export default AppLayout;
